<div class="chase-detail-info-chart-container">
  <div class="chart-section-container">
    <div class="chart-section-header section-headers">Chart</div>
    <div class="chart-section-body">
      <img *ngIf="chartImageString" [src]="'data:image/jpg;base64,'+chartImageString" />
      <div class="numberofpages bold">{{numberOfPages}} Pgs</div>
      <app-button text="VIEW CHART"></app-button>
    </div>
  </div>
  <div class="latest-document-section-container">
    <div class="latest-document-section-header section-headers">LATEST DOCUMENTS</div>
    <div class="latest-document-section-body">
      <app-chase-document-list display="block" width="500px" height="200px" maxDocuments="3"></app-chase-document-list>
      <app-button text="VIEW ALL DOCUMENTS"></app-button>
    </div>
  </div>
</div>